import { useForm } from '@/@fuse/hooks';
import CustomButton from '@/app/customComponents/CustomButton/CustomButton';
import { resetPassword } from '@/app/services/Superadminprodile/Superadminprodile';
import * as Actions from '@/app/store/actions';
import { CircularProgress } from '@material-ui/core';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import TextField from '@material-ui/core/TextField';
import VisibilityIcon from '@material-ui/icons/Visibility';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import { useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './adminDetail.css';
import { Close } from '@material-ui/icons';

const ResetDialoguebox = ({ setRefresh, refresh }) => {
	const [isRequesting, setIsRequesting] = useState(false);
	const dispatch = useDispatch();
	const [hide1, setHide1] = useState(true);
	const [hide2, setHide2] = useState(true);
	const [hide3, setHide3] = useState(true);
	const [newPswdTxt, setNewPswdTxt] = useState('');
	const [pswd2Txt, setPswd2Txt] = useState('');
	const [errTxts, setErrTxts] = useState({});
	const userRole = useSelector(({ auth }) => auth.user.role);
	const isSuperSchoolAdmin = userRole[0] === 'super_school_admin';

	const handleChange = (e) => {
		setForm({
			...form,
			[e.target.name]: e.target.value,
		});
		if (e.target.name === 'password_confirmation') {
			setPswd2Txt('');
		}
		if (e.target.name === 'old_password') {
			setErrTxts({});
		}
		if (e.target.name === 'password') {
			setNewPswdTxt('');
		}
	};

	const { form, setForm } = useForm({
		old_password: '',
		password: '',
		password_confirmation: '',
	});

	function handleSubmit(e) {
		e.preventDefault();

		if (!form.old_password) {
			setErrTxts({ password: 'This field is required' });
			return;
		}

		if (!form.password.length) {
			setNewPswdTxt('This field is required');
			return;
		}

		if (form.password.length < 8) {
			setNewPswdTxt('Password Length must be eight or more characters.');
			return;
		}
		if (form.password.toUpperCase() === form.password) {
			setNewPswdTxt('Password must contain one lowercase string.');
			return;
		}
		if (form.password.toLowerCase() === form.password) {
			setNewPswdTxt('Password must contain one uppercase character.');
			return;
		}
		if (!/\d/.test(form.password)) {
			setNewPswdTxt('Password must contain one number.');
			return;
		}
		if (!/[ `!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?~]/.test(form.password)) {
			setNewPswdTxt('Password must contain one special character.');
			return;
		}
		if (!form.password_confirmation) {
			setPswd2Txt('This field is required');
			return;
		}

		if (form.password !== form.password_confirmation) {
			setPswd2Txt('Password and Confirm Password must be same.');
			return;
		}

		if (form.old_password === form.password) {
			setNewPswdTxt('New password cannot be the same as old password.');
			return;
		}

		setIsRequesting(true);
		const data = {
			old_password: form.old_password,
			password: form.password,
			password_confirmation: form.password_confirmation,
		};
		resetPassword(data, isSuperSchoolAdmin)
			.then(() => {
				// setUsername(null);
				setIsRequesting(false);
				dispatch(
					Actions.showMessage({
						message: `Password updated successfully.`,
						variant: 'success',
						autoHideDuration: 3000,
					}),
				);
				setRefresh(!refresh);
				dispatch(Actions.closeDialog());
			})
			.catch((err) => {
				setIsRequesting(false);
				dispatch(
					Actions.showMessage({
						message: err.response.data.message || 'Failed to update password',
						autoHideDuration: 1500,
						variant: 'error',
					}),
				);
				if (err.response.data.errors) {
					setErrTxts(err.response.data.errors);
				}
			});
	}

	return (
		<div className="popupp">
			<div className="top-popup">
				{/* <div className='top-baar flex items-center flex-nowrap justify-between mx-auto'>
					<div className='text-pd-2xl font-extrabold'>
						<h2>Reset Password</h2>
					</div>
					<span className='flex justify-between"' onClick={() => dispatch(Actions.closeDialog())}>x</span>
				</div> */}

				<div className="flex justify-between school-list-headerr">
					<div className="text-pd-2xl font-extrabold ">
						<h1 className="left-hd" style={{ fontSize: '20px', fontWeight: '700' }}>
							Reset Password
						</h1>
					</div>
					<div>
						<button onClick={() => dispatch(Actions.closeDialog())} style={{ cursor: 'pointer' }} type="button">
							<Close />
						</button>
					</div>
				</div>
				<form>
					<div className="insert">
						<TextField
							InputProps={{
								endAdornment: (
									<InputAdornment position="end">
										<IconButton onClick={() => setHide3(!hide3)}>
											{hide3 ? <VisibilityOffIcon /> : <VisibilityIcon />}
										</IconButton>
									</InputAdornment>
								),
							}}
							className="mb-16 w-full"
							error={!!errTxts.password}
							helperText={errTxts.password}
							id="old_password"
							label="Old Password"
							name="old_password"
							onChange={handleChange}
							required
							type={hide3 ? 'password' : 'text'}
							value={form.old_password}
						/>
					</div>
					<div className="insert">
						<TextField
							InputProps={{
								endAdornment: (
									<InputAdornment position="end">
										<IconButton onClick={() => setHide1(!hide1)}>
											{hide1 ? <VisibilityOffIcon /> : <VisibilityIcon />}
										</IconButton>
									</InputAdornment>
								),
							}}
							className="mb-16 w-full"
							error={!!newPswdTxt.length}
							helperText={newPswdTxt}
							id="password"
							label="New Password"
							name="password"
							onChange={handleChange}
							required
							type={hide1 ? 'password' : 'text'}
							value={form.password}
						/>
					</div>
					<div className="insert">
						<TextField
							InputProps={{
								endAdornment: (
									<InputAdornment position="end">
										<IconButton onClick={() => setHide2(!hide2)}>
											{hide2 ? <VisibilityOffIcon /> : <VisibilityIcon />}
										</IconButton>
									</InputAdornment>
								),
							}}
							className="mb-16 w-full"
							error={!!pswd2Txt.length}
							fullWidth
							helperText={pswd2Txt}
							id="password_confirmation"
							label="Confirm Password"
							name="password_confirmation"
							onChange={handleChange}
							required
							type={hide2 ? 'password' : 'text'}
							value={form.password_confirmation}
						/>
					</div>
				</form>

				{isRequesting ? (
					<CircularProgress />
				) : (
					<div className="flex justify-center" style={{ gap: 20 }}>
						<CustomButton
							fontSize="15px"
							height="35px"
							onClick={() => dispatch(Actions.closeDialog())}
							variant="secondary"
							width="135px"
						>
							Cancel
						</CustomButton>
						<CustomButton
							fontSize="15px"
							height="35px"
							onClick={(e) => handleSubmit(e)}
							type="submit"
							variant="primary"
							width="135px"
						>
							Reset
						</CustomButton>
					</div>
				)}
			</div>
		</div>
	);
};

export default ResetDialoguebox;
